/*
 * @Author: liyxt
 * @Date: 2019-10-14 14:11:58
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:35:45
 * @Description: file content
 */
import React, { Component } from 'react';
import OriginAutoComplete from 'bee-autocomplete';

require('bee-autocomplete/build/AutoComplete.css');

class AutoComplete extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <OriginAutoComplete {...this.props} />;
	}
}
export default AutoComplete;
